import { Reducer, Action } from 'redux';
import { IRootState } from './index';
import { takeEvery, fork, put, call, select } from 'redux-saga/effects';
import Api from '../api';
import { apiCall } from './SagaUtil';
import IOwner from 'src/models/IOwner';
import Owner from 'src/models/tract_detail/Owner';
// import OwnerDetail from 'src/models/tract_detail/OwnerDetail';
import Ownership from 'src/models/tract_detail/Ownership';
// import { replace } from 'connected-react-router';
import ErrorResponse from '../models/ErrorResponse';

import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { selectors as authSelectors } from 'src/reducers/Auth';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import MergeContainer from 'src/models/MergeContainer';

// Store
export interface IOwnerState {
    ownershipDetail: Ownership;
    owners: Array<Owner>;
    ownerDetail: IOwner;
    isOwnershipDetailLoading: boolean;
    ownerDetails: Array<IOwner>;
    targetOwnerDetails: Array<IOwner>;
    pageUpdated: boolean;
    error: string;
}

const initialState: IOwnerState = {
    ownershipDetail: undefined,
    owners: undefined,
    ownerDetail: undefined,
    isOwnershipDetailLoading: false,
    ownerDetails: undefined,
    targetOwnerDetails: undefined,
    pageUpdated: false,
    error: undefined,
};

// Action Types
export enum actionTypes {
    GET_OWNERSHIP_DETAIL = '[owner] GET_OWNERSHIP_DETAIL',
    GET_OWNERSHIP_DETAIL_SUCCESS = '[owner] GET_OWNERSHIP_DETAIL_SUCCESS',
    GET_OWNERS = '[owner] GET_OWNERS',
    GET_OWNERS_SUCCESS = '[owner] GET_OWNERS_SUCCESS',
    GET_OWNER_DETAILS = '[owner] GET_OWNER_DETAILS',
    GET_TARGET_OWNER_DETAILS = '[owner] GET_TARGET_OWNER_DETAILS',
    GET_OWNER_DETAILS_SUCCESS = '[owner] GET_OWNER_DETAILS_SUCCESS',
    GET_TARGET_OWNER_DETAILS_SUCCESS = '[owner] GET_TARGET_OWNER_DETAILS_SUCCESS',
    UPDATE_OWNER_DETAIL = '[owner] UDPATE_OWNER_DETAIL',
    UPDATE_INDIVIDUAL_OWNER = '[owner] UPDATE_INDIVIDUAL_OWNER',
    UPDATE_TRUST_OWNER = '[owner] UPDATE_TRUST_OWNER',
    UPDATE_BUSINESS_OWNER = '[owner] UPDATE_BUSINESS_OWNER',
    UPDATE_GOV_BOLM_OWNER = '[owner] UPDATE_GOV_BOLM_OWNER',
    UPDATE_GOV_RAL_OWNER = '[owner] UPDATE_GOV_RAL_OWNER',
    UPDATE_GOV_STATE_LAND_OWNER = '[owner] UPDATE_GOV_STATE_LAND_OWNER',
    UPDATE_JOINT_TENANT_OWNER = '[owner] UPDATE_JOINT_TENANT_OWNER',
    UPDATE_OWNER_SUCCESS = '[owner] UPDATE_OWNER_SUCCESS',
    ADD_DEVIATION = '[owner] ADD_DEVIATION',
    ADD_DEVIATION_SUCCESS = '[owner] ADD_DEVIATION_SUCCESS',
    ADD_DEVIATION_FAILURE = '[owner] ADD_DEVIATION_FAILURE',
    CHANGE_PRIMARY = '[owner] CHANGE_PRIMARY',
    CHANGE_PRIMARY_SUCCESS = '[owner] CHANGE_PRIMARY_SUCCESS',
    CLEAR_TARGET_DEVIATIONS = '[owner] CLEAR_TARGET_DEVIATIONS',
    MERGE_CONTAINER = '[owner] MERGE_CONTAINER',
    MERGE_CONTAINER_SUCCESS = '[owner] MERGE_CONTAINER_SUCCESS',
    SEPARATE_DEVIATION = '[owner] SEPARATE_DEVIATION',
    SEPARATE_DEVIATION_SUCCESS = '[owner] SEPARATE_DEVIATION_SUCCESS',
    CREATE_BUSINESS_OWNER = '[owner] CREATE_BUSINESS_OWNER',
    GET_OWNER_INFO = '[owner] GET_OWNER_INFO',
    GET_OWNER_INFO_SUCCESS = '[owner] GET_OWNER_INFO_SUCCESS',
    RESET_BANNER = '[owner] RESET_BANNER'
}

// Action Creator
export const actionCreators = {
    getOwnershipDetail: (payload: { projectId: number; ownershipDetailId: number }) => {
        return { type: actionTypes.GET_OWNERSHIP_DETAIL, payload };
    },
    getOwnershipDetailSuccess: (ownership: Ownership) => {
        return { type: actionTypes.GET_OWNERSHIP_DETAIL_SUCCESS, payload: ownership };
    },
    getOwners: (projectId: number) => {
        return { type: actionTypes.GET_OWNERS, payload: projectId };
    },
    getOwnersSuccess: (owners: Array<Owner>) => {
        return { type: actionTypes.GET_OWNERS_SUCCESS, payload: owners };
    },
    getOwnerDetails: (clientNumber: number, projectNumber: number, ownerId: number, containerId: number, type: string) => {
        return { type: actionTypes.GET_OWNER_DETAILS, payload: { clientNumber, projectNumber, ownerId, containerId, type } };
    },
    getTargetOwnerDetails: (clientNumber: number, projectNumber: number, ownerId: number, containerId: number, type: string) => {
        return { type: actionTypes.GET_TARGET_OWNER_DETAILS, payload: { clientNumber, projectNumber, ownerId, containerId, type } };
    },
    changePrimary: (clientNumber: number, projectNumber: number, owner: IOwner) => {
        return { type: actionTypes.CHANGE_PRIMARY, payload: { clientNumber, projectNumber, owner } };
    },
    separateDeviation: (clientNumber: number, projectNumber: number, owner: IOwner) => {
        return { type: actionTypes.SEPARATE_DEVIATION, payload: { clientNumber, projectNumber, owner } };
    },
    mergeContainer: (clientNumber: number, projectNumber: number, primaryOwnerId: number, mergeContainer: MergeContainer) => {
        return { type: actionTypes.MERGE_CONTAINER, payload: { clientNumber, projectNumber, mergeContainer, primaryOwnerId } };
    },
    mergeContainerSuccess: () => {
        return { type: actionTypes.MERGE_CONTAINER_SUCCESS };
    },
    clearTargetDeviations: () => {
        return { type: actionTypes.CLEAR_TARGET_DEVIATIONS };
    },
    addDeviation: (clientNumber: number, projectNumber: number, addOwnership: AddOwner, containerOwnerId: number, ownerType: string) => {
        return { type: actionTypes.ADD_DEVIATION, payload: { clientNumber, projectNumber, addOwnership, containerOwnerId, ownerType } };
    },
    addDeviationSuccess: () => {
        return { type: actionTypes.ADD_DEVIATION_SUCCESS };
    },
    addDeviationFailure: (errorResponse: ErrorResponse) => {
        return { type: actionTypes.ADD_DEVIATION_FAILURE, payload: errorResponse };
    },
    getOwnerDetailsSuccess: (ownerDetails: Array<IOwner>) => {
        return { type: actionTypes.GET_OWNER_DETAILS_SUCCESS, payload: ownerDetails };
    },
    getTargetOwnerDetailsSuccess: (ownerDetails: Array<IOwner>) => {
        return { type: actionTypes.GET_TARGET_OWNER_DETAILS_SUCCESS, payload: ownerDetails };
    },
    changePrimarySuccess: () => {
        return { type: actionTypes.CHANGE_PRIMARY_SUCCESS };
    },
    separateDeviationSuccess: () => {
        return { type: actionTypes.SEPARATE_DEVIATION_SUCCESS };
    },
    updateIndividualOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_INDIVIDUAL_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateTrustOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_TRUST_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateBusinessOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_BUSINESS_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateGovBOLMOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_GOV_BOLM_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateGovRALOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_GOV_RAL_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateGovStateLandOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_GOV_STATE_LAND_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    updateJointTenantOwner: (clientNumber: number, projectNumber: number, ownerId: number, ownerDetail: IOwner) => {
        return { type: actionTypes.UPDATE_JOINT_TENANT_OWNER, payload: { clientNumber, projectNumber, ownerId, ownerDetail } };
    },
    createBusinessOwner: (clientNumber: number, projectNumber: number, owner: IOwner) => {
        return { type: actionTypes.CREATE_BUSINESS_OWNER, payload: { clientNumber, projectNumber, owner } };
    },
    getOwnerInfo: (clientNumber: number, projectNumber: number, ownerLookUpId: number) => {
        return { type: actionTypes.GET_OWNER_INFO, payload: { clientNumber, projectNumber, ownerLookUpId } };
    },
    getOwnerInfoSuccess: (payload: IOwner) => {
        return { type: actionTypes.GET_OWNER_INFO_SUCCESS, payload };
    },
    updateOwnerSuccess: () => {
        return { type: actionTypes.UPDATE_OWNER_SUCCESS };
    },
    resetBanner: () => {
        return { type: actionTypes.RESET_BANNER };
    }
};

// Reducer
const reducer: Reducer<IOwnerState> = (state: IOwnerState = initialState, action: Action): IOwnerState => {
    switch (action.type) {
        case actionTypes.GET_OWNERSHIP_DETAIL: {
            return {
                ...state,
                isOwnershipDetailLoading: true,
            };
        }
        case actionTypes.GET_OWNERSHIP_DETAIL_SUCCESS: {
            const payload = (action as { type: string; payload: Ownership }).payload;
            return {
                ...state,
                ownershipDetail: payload,
                isOwnershipDetailLoading: false,
            };
        }
        case actionTypes.GET_OWNERS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<Owner> }).payload;
            return {
                ...state,
                owners: payload,
            };
        }
        case actionTypes.GET_OWNER_DETAILS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<IOwner> }).payload;
            return {
                ...state,
                ownerDetails: payload,
            };
        }
        case actionTypes.GET_TARGET_OWNER_DETAILS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<IOwner> }).payload;
            return {
                ...state,
                targetOwnerDetails: payload,
            };
        }
        case actionTypes.ADD_DEVIATION_FAILURE: {
            const payload = (action as { type: string; payload: ErrorResponse }).payload;
            return {
                ...state,
                error: payload.message,
            };
        }
        case actionTypes.CLEAR_TARGET_DEVIATIONS: {
            return {
                ...state,
                targetOwnerDetails: undefined,
            };
        }
        case actionTypes.GET_OWNER_INFO_SUCCESS: {
            const payload = (action as { type: string; payload: IOwner }).payload;
            return {
                ...state,
                ownerDetail: payload,
            };
        }
        case actionTypes.UPDATE_OWNER_SUCCESS: {
            return {
                ...state,
                pageUpdated: true
            };
        }
        case actionTypes.RESET_BANNER: {
            return {
                ...state,
                pageUpdated: false
            };
        }
        default:
            return state;
    }
};

export default reducer;

// Selectors
const ownershipDetailSelector = (state: IRootState): Ownership => state.owner.ownershipDetail;
const ownerDetailsSelector = (state: IRootState): Array<IOwner> => state.owner.ownerDetails;
const targetOwnerDetailsSelector = (state: IRootState): Array<IOwner> => state.owner.targetOwnerDetails;
const pageUpdatedSelector = (state: IRootState): boolean => state.owner.pageUpdated;

export const selectors = {
    ownershipDetailSelector: ownershipDetailSelector,
    ownerDetailsSelector: ownerDetailsSelector,
    targetOwnerDetailsSelector: targetOwnerDetailsSelector,
    pageUpdatedSelector: pageUpdatedSelector
};

// Side-Effects
const sagas = {
    getOwnershipDetail: function* (action: { type: string; payload: { ownerId: number; horizonId: number; projectId: number; tractId: number } }): unknown {
        const result = yield apiCall(
            action.type,
            Api.Tract.getOwnershipDetail,
            action.payload.ownerId,
            action.payload.horizonId,
            action.payload.projectId,
            action.payload.tractId
        );
        yield put(actionCreators.getOwnershipDetailSuccess(result));
    },
    getOwners: function* (action: { type: string; payload: number }): unknown {
        const result = yield apiCall(action.type, Api.Owner.getOwners, action.payload);
        yield put(actionCreators.getOwnersSuccess(result));
    },
    getOwnerDetails: function* (action: { type: string; payload: { projectId: number; ownerId: number; containerId: number; type: string } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Owner.getOwnerDetails,
            action.payload.projectId,
            action.payload.ownerId,
            action.payload.containerId,
            action.payload.type,
            jwt
        );
        yield put(actionCreators.getOwnerDetailsSuccess(result));
    },
    getTargetOwnerDetails: function* (action: { type: string; payload: { projectId: number; ownerId: number; containerId: number; type: string } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Owner.getOwnerDetails,
            action.payload.projectId,
            action.payload.ownerId,
            action.payload.containerId,
            action.payload.type,
            jwt
        );
        yield put(actionCreators.getTargetOwnerDetailsSuccess(result));
    },
    changePrimary: function* (action: { type: string; payload: { clientNumber: number; projectNumber: number; type: string; owner: IOwner } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, owner } = action.payload;
        switch (owner.ownerType) {
            case 'Individual':
                yield call(Api.Owner.changeIndividualPrimary, owner as OwnerIndividual, jwt);
                break;
            case 'Trust':
                yield call(Api.Owner.changeTrustPrimary, owner as OwnerTrust, jwt);
                break;
            case 'Business':
                yield call(Api.Owner.changeBusinessPrimary, owner as OwnerBusiness, jwt);
                break;
            case 'Gov-BLM':
                yield call(Api.Owner.changeGovBLMPrimary, owner as OwnerBOLM, jwt);
                break;
            case 'Gov-RAL':
                yield call(Api.Owner.changeGovRALPrimary, owner as OwnerRAL, jwt);
                break;
            case 'Gov-State':
                yield call(Api.Owner.changeGovStatePrimary, owner as OwnerStateLand, jwt);
                break;
            default:
                break;
        }
        yield put(actionCreators.changePrimarySuccess());
        yield put(actionCreators.getOwnerDetails(clientNumber, projectNumber, owner.id, owner.containerOwnerId, owner.ownerType));
    },
    separateDeviation: function* (action: { type: string; payload: { clientNumber: number; projectNumber: number; type: string; owner: IOwner } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, owner } = action.payload;
        switch (owner.ownerType) {
            case 'Individual':
                yield call(Api.Owner.separateIndividualDeviation, clientNumber, projectNumber, owner as OwnerIndividual, jwt);
                break;
            case 'Trust':
                yield call(Api.Owner.separateTrustDeviation, clientNumber, projectNumber, owner as OwnerTrust, jwt);
                break;
            case 'Business':
                yield call(Api.Owner.separateBusinessDeviation, clientNumber, projectNumber, owner as OwnerBusiness, jwt);
                break;
            case 'Gov-BLM':
                yield call(Api.Owner.separateGovBLMDeviation, clientNumber, projectNumber, owner as OwnerBOLM, jwt);
                break;
            case 'Gov-RAL':
                yield call(Api.Owner.separateGovRALDeviation, clientNumber, projectNumber, owner as OwnerRAL, jwt);
                break;
            case 'Gov-State':
                yield call(Api.Owner.separateGovStateDeviation, clientNumber, projectNumber, owner as OwnerStateLand, jwt);
                break;
            default:
                break;
        }

        yield put(actionCreators.separateDeviationSuccess());
        yield put(actionCreators.getOwnerDetails(clientNumber, projectNumber, owner.id, owner.containerOwnerId, owner.ownerType));
    },
    mergeContainer: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; primaryOwnerId: number; mergeContainer: MergeContainer };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, primaryOwnerId, mergeContainer } = action.payload;
        yield call(Api.Owner.mergeContainer, clientNumber, projectNumber, mergeContainer, jwt);
        yield put(actionCreators.mergeContainerSuccess());
        yield put(
            actionCreators.getOwnerDetails(clientNumber, projectNumber, primaryOwnerId, mergeContainer.containerToKeep, mergeContainer.ownerType)
        );
    },
    updateIndividualOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateIndividualOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateTrustOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateTrustOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateBusinessOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateBusinessOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateGovBOLMOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateGovBOLMOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateGovRALOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateGovRALOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateGovStateLandOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateGovStateLandOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    updateJointTenantOwner: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; ownerId: number; ownerDetail: IOwner };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        yield call(
            Api.Owner.updateJointTenantOwner,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.ownerId,
            action.payload.ownerDetail,
            jwt
        );
        yield put(actionCreators.updateOwnerSuccess());
    },
    addDeviation: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; addOwnership: AddOwner; containerOwnerId: number; ownerType: string };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(
            Api.Owner.addDeviation,
            action.payload.clientNumber,
            action.payload.projectNumber,
            action.payload.addOwnership,
            jwt
        );
        if (result instanceof ErrorResponse) {
            actionCreators.addDeviationFailure(result);
        } else {
            yield put(actionCreators.addDeviationSuccess());
            // tslint:disable-next-line:max-line-length
            yield put(
                actionCreators.getOwnerDetails(
                    action.payload.clientNumber,
                    action.payload.projectNumber,
                    0,
                    action.payload.containerOwnerId,
                    action.payload.ownerType
                )
            );
        }
    },
    createBusinessOwner: function* (action: { type: string; payload: { clientNumber: number; projectNumber: number; owner: IOwner } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, owner } = action.payload;
        yield call(Api.Owner.createBusinessOwner, clientNumber, projectNumber, owner, jwt);
    },
    getOwnerInfo: function* (action: { type: string; payload: { clientNumber: number; projectNumber: number; ownerLookUpId: number } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, ownerLookUpId } = action.payload;
        const result = yield call(Api.Owner.getOwnerInfo, clientNumber, projectNumber, ownerLookUpId, jwt);
        yield put(actionCreators.getOwnerInfoSuccess(result));
    },
};

const watches = {
    addDeviation: function* () {
        yield takeEvery(actionTypes.ADD_DEVIATION, sagas.addDeviation);
    },
    getOwnershipDetail: function* () {
        yield takeEvery(actionTypes.GET_OWNERSHIP_DETAIL, sagas.getOwnershipDetail);
    },
    getOwners: function* () {
        yield takeEvery(actionTypes.GET_OWNERS, sagas.getOwners);
    },
    getOwnerDetails: function* () {
        yield takeEvery(actionTypes.GET_OWNER_DETAILS, sagas.getOwnerDetails);
    },
    getTargetOwnerDetails: function* () {
        yield takeEvery(actionTypes.GET_TARGET_OWNER_DETAILS, sagas.getTargetOwnerDetails);
    },
    updateIndividualOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_INDIVIDUAL_OWNER, sagas.updateIndividualOwner);
    },
    updateTrustOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_TRUST_OWNER, sagas.updateTrustOwner);
    },
    updateBusinessOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_BUSINESS_OWNER, sagas.updateBusinessOwner);
    },
    updateGovBOLMOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_GOV_BOLM_OWNER, sagas.updateGovBOLMOwner);
    },
    updateGovRALOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_GOV_RAL_OWNER, sagas.updateGovRALOwner);
    },
    updateGovStateLandOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_GOV_STATE_LAND_OWNER, sagas.updateGovStateLandOwner);
    },
    updateJointTenantOwner: function* () {
        yield takeEvery(actionTypes.UPDATE_JOINT_TENANT_OWNER, sagas.updateJointTenantOwner);
    },
    changePrimary: function* () {
        yield takeEvery(actionTypes.CHANGE_PRIMARY, sagas.changePrimary);
    },
    separateDeviation: function* () {
        yield takeEvery(actionTypes.SEPARATE_DEVIATION, sagas.separateDeviation);
    },
    mergeContainer: function* () {
        yield takeEvery(actionTypes.MERGE_CONTAINER, sagas.mergeContainer);
    },
    createBusinessOwner: function* () {
        yield takeEvery(actionTypes.CREATE_BUSINESS_OWNER, sagas.createBusinessOwner);
    },
    getOwnerInfo: function* () {
        yield takeEvery(actionTypes.GET_OWNER_INFO, sagas.getOwnerInfo);
    },
};

export function* saga() {
    yield fork(watches.changePrimary);
    yield fork(watches.separateDeviation);
    yield fork(watches.mergeContainer);
    yield fork(watches.addDeviation);
    yield fork(watches.getOwnershipDetail);
    yield fork(watches.getOwners);
    yield fork(watches.getOwnerDetails);
    yield fork(watches.getTargetOwnerDetails);
    yield fork(watches.updateIndividualOwner);
    yield fork(watches.updateTrustOwner);
    yield fork(watches.updateBusinessOwner);
    yield fork(watches.updateGovBOLMOwner);
    yield fork(watches.updateGovRALOwner);
    yield fork(watches.updateGovStateLandOwner);
    yield fork(watches.updateJointTenantOwner);
    yield fork(watches.createBusinessOwner);
    yield fork(watches.getOwnerInfo);
}



// WEBPACK FOOTER //
// ./src/reducers/Owner.ts